export const Prose = ({ html, className = "", testId }) => (
  <div className={`prose-avter ${className}`} dangerouslySetInnerHTML={{ __html: html || "" }} data-testid={testId} />
);
